package com.essntl.features.organization.ui

import core.validation.Form
import core.validation.field.Field
import core.validation.field.StringField
import core.validation.validator.NonEmptyValidator

class OrganizationValidation {
    val organizationForm = OrganizationForm()
}

class OrganizationForm : Form() {
    val name = StringField(NonEmptyValidator)

    override val fields: List<Field>
        get() = listOf(name)
}